import { Icon } from '@ps/isp-web-component-library';
import { SearchMenu } from '@ps/isp-web-component-library/icons/SearchMenu';
import type { LinkProps } from '@ps/web-shared-components';
import { Link } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import { Icon as SWIcon } from '@swf/sports/components';
import type { IconName } from '@swf/sports/types/icon';

import styles from './HorizontalMenuItem.scss';

export interface Props extends LinkProps {
  icon: IconName;
  isIconOnly?: boolean;
  onClick?: () => void;
  text: React.ReactNode;
  url?: string;
  className?: string;
}

const HorizontalMenuItem: React.FC<Props> = ({
  icon,
  isIconOnly,
  onClick,
  text,
  url,
  isActive = (_, { pathname }) => (url ? pathname.startsWith(url) : false),
  className
}) => {
  // TODO Deprecate old Icon component and SVGs in favour of Component Library - https://jira.pyrsoftware.ca/jira/browse/GSFET-1939
  const children = (
    <>
      {icon === 'sports-menu' ? (
        <Icon
          icon={SearchMenu}
          className={classNames(styles.item, className)}
          size="x2.5"
          data-testid="sports-icon"
        />
      ) : (
        <SWIcon name={icon} className={styles.icon} size="x2.5" />
      )}

      <span className={styles.text}>{text}</span>
    </>
  );

  return (
    <li className={classNames(styles.item, className)}>
      {onClick ? (
        <button
          type="button"
          className={classNames(styles.link, { [styles.iconOnly]: isIconOnly })}
          onClick={onClick}
        >
          {children}
        </button>
      ) : (
        <Link
          isActive={isActive}
          className={classNames(styles.link, { [styles.iconOnly]: isIconOnly })}
          href={url}
          activeClassName={classNames(styles.activeLink)}
        >
          {children}
        </Link>
      )}
    </li>
  );
};

export default HorizontalMenuItem;
